<template>
  <div :key="'fields-' + index + n" class="mb-3" :id="field.field_type_id">
    <template v-if="field.field_type_id == 1">
      <InputText
        :textFloat="field.name"
        :placeholder="field.name"
        v-model="field.value"
        :disabled="isDisabled"
        :isValidate="v && v.$each.$iter[index].value.$error"
        :isRequired="field.is_required == 1 ? true : false"
        class="mb-0"
      />
    </template>

    <template v-else-if="field.field_type_id == 2">
      <label class="label" :for="'checkbox-' + n + index">
        {{ field.name }}
        <span v-if="field.is_required == 1 ? true : false" class="text-error"
          >*</span
        >
      </label>

      <b-form-checkbox-group
        :disabled="isDisabled"
        :state="v && !v.$each.$iter[index].value.$error"
        :id="'checkbox-' + n + index"
        v-model="field.value"
      >
        <b-form-checkbox
          :disabled="isDisabled"
          v-for="choice of field.field_choices"
          :value="choice.id"
          :key="choice.name + choice.id"
          >{{ choice.name }}
        </b-form-checkbox>
      </b-form-checkbox-group>
    </template>
    <template v-else-if="field.field_type_id == 3">
      <label class="label" :for="'radio-' + n + index">
        {{ field.name }}
        <span v-if="field.is_required == 1 ? true : false" class="text-error"
          >*</span
        >
      </label>

      <b-form-radio-group
        :id="'radio-' + n + index"
        v-model="field.value"
        :options="field.field_choices"
        :name="'radio-' + n + index"
        value-field="id"
        text-field="name"
        :disabled="isDisabled"
      ></b-form-radio-group>
    </template> 
    <template v-else-if="field.field_type_id == 4">
      <InputSelect
        :disabled="isDisabled"
        :title="field.name"
        :options="field.field_choices"
        value-field="id"
        text-field="name"
        :name="'select-' + n + index"
         @onDataChange="(val) => field.value = val"
        v-model="field.value"
        :isValidate="v && v.$each.$iter[index].value.$error"
        :isRequired="field.is_required == 1 ? true : false"
      >
        <template v-slot:option-first>
          <b-form-select-option value="" disabled
            >-- Select {{ field.name }} --</b-form-select-option
          >
        </template>
      </InputSelect>
    </template>
    <template v-else-if="field.field_type_id == 5">
      <p class="label">{{ field.name }}</p>
      <div class="datetime-container">
        <datetime
          :disabled="isDisabled"
          :isRequired="field.is_required == 1 ? true : false"
          :textFloat="field.name"
          type="datetime"
          :name="'date-' + n + index"
          :class="[
            'date-picker-input',
            'date-filter',
            { 'disabled-bg': isDisabled },
          ]"
          :ref="'date-' + n + index"
          v-model="field.value"
          @input="(val) => (field.value = val)"
          class="datetime-h custom-date-picker"
          format="dd/MM/yyyy hh:mm"
          :isValidate="v && v.$each.$iter[index].value.$error"
        />
        <div class="calendar-icon">
          <font-awesome-icon icon="calendar-alt" />
        </div>
      </div>
      <!-- <FieldDateTime :field="field" /> -->
    </template>
    <template v-else-if="field.field_type_id == 6">
      <InputSelect
        :disabled="isDisabled"
        :title="field.name"
        :options="field.branch_list"
        value-field="id"
        text-field="name"
        :name="'select-' + n + index"
        v-model="field.value"
         @onDataChange="(val) => field.value  = val"
        :isValidate="v && v.$each.$iter[index].value.$error"
        :isRequired="field.is_required == 1 ? true : false"
      >
        <template v-slot:option-first>
          <b-form-select-option value="" disabled
            >-- Select {{ field.name }} --</b-form-select-option
          >
        </template>
      </InputSelect>
    </template>
    <template v-else-if="field.field_type_id == 7">
      <p class="label">{{ field.name }}</p>
      <div class="datetime-container">
        <datetime
          :disabled="isDisabled"
          :isRequired="field.is_required == 1 ? true : false"
          :textFloat="field.name"
          type="date"
          :name="'date-' + n + index"
          :class="[
            'date-picker-input',
            'date-filter',
            { 'disabled-bg': isDisabled },
          ]"
          :ref="'date-' + n + index"
          v-model="field.value"
          @input="(val) => (field.value = val)"
          class="datetime-h custom-date-picker"
          format="dd/MM/yyyy "
          :isValidate="v && v.$each.$iter[index].value.$error"
        />
        <div class="calendar-icon">
          <font-awesome-icon icon="calendar-alt" />
        </div>
      </div>
    </template>
    <template v-else-if="field.field_type_id == 8">
      <label class="label">{{ field.name }}</label>
      <InputUploadImage
        :disabled="isDisabled"
        :id="field.id"
        label=""
        :img="field.value"
        v-model="field.value"
        :isValidate="v && v.$each.$iter[index].value.$error"
        :isRequired="field.is_required == 1 ? true : false"
      />
      <div class="f-xs color-gray mt-1">
        ไฟล์ที่อัพโหลดต้องเป็นไฟล์นามสกุล PDF, PNG ,JPG ขนาดไม่เกิน 2.5 mb
        เท่านั้น
      </div>
      <div v-if="field.value">
        <!-- <PreviewBox
            v-on:delete="onDeleteImage(index)"
            :disabled="field.isLoading"
            :showPreviewType="0"
            :showPreview="field.value"
            :isLoadingImage="field.isLoading"
            :ratioType="1"
            small
            class="mb-3"
          /> -->
      </div>
    </template>
    <template v-else-if="field.field_type_id == 12">
      <InputTextArea
        :disabled="isDisabled"
        :isRequired="field.is_required == 1 ? true : false"
        :placeholder="field.name"
        :textFloat="field.name"
        v-model="field.value"
        :isValidate="v && v.$each.$iter[index].value.$error"
      />
    </template>
    <div v-if="v && v.$each.$iter[index].value.$error" class="text-error">
      {{ field.validate_text }}
    </div>
  </div>
</template>

<script>
import InputUploadImage from "@/components/inputs/InputUploadImage.vue";
export default {
  components: { InputUploadImage },
  props: {
    field: { required: true },
    form: { required: false },
    // fieldsIndex: { required: true },
    v: { required: false, default: null },
    n: { required: false },
    index: { required: false },
    isDisabled: { required: false, default: false },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.calendar-icon {
  position: absolute;
  top: 20%;
  right: 3%;
}
.calendar-icon-top {
  top: 35% !important;
}
.datetime-container {
  position: relative;
  //   width: 230px;
}

.custom-date-picker ::v-deep input {
  height: 35px !important;
}

.label {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: bold !important;
}

.disabled-bg ::v-deep .vdatetime-input {
  background: light-dark(
    rgba(223, 221, 221, 0.148),
    rgba(59, 59, 59, 0.3)
  ) !important;
}
</style>
